import { render, staticRenderFns } from "./StandingOrderDrug.vue?vue&type=template&id=d744b2e4&scoped=true&"
import script from "./StandingOrderDrug.vue?vue&type=script&lang=js&"
export * from "./StandingOrderDrug.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrderDrug.vue?vue&type=style&index=0&id=d744b2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d744b2e4",
  null
  
)

export default component.exports